import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Button, FormGroup, Col, Label, Input } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import Loader from '../../../common/Loader';
import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import FileDetailResource from '../../../common/resource/FileDetailResource';
import { getCargoCorporateCreditExcelTemplate } from '../../../../actions';

const CargoCorporateCreditCustomerModalForm = ({
  handleSubmit,
  onCancel,
  loading,
  dispatchTemplate,
  cargoCorporateCreditId,
  onSubmit,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const isExcelFileTypeValid = (uploadedFile) => {
    const validExcelFileExtensions = ['.xlsx'];
    const uploadedFileNameInLowerCase = uploadedFile.name.toLowerCase();
    return validExcelFileExtensions.some((extension) =>
      uploadedFileNameInLowerCase.endsWith(extension),
    );
  };

  const onChangeFile = (e) => {
    const file = e.target.files[0];
    if (file && isExcelFileTypeValid(file)) {
      setSelectedFile(file);
    } else {
      toastr.error('Error', 'Sólo se permiten archivos con extensión .xlsx');
      e.target.value = null;
      setSelectedFile(null);
    }
  };

  const downloadTemplate = () => {
    dispatchTemplate({ cargoCorporateCreditId });
  };

  const submitForm = () => {
    if (!selectedFile) {
      toastr.error('Error', 'Debe seleccionar un archivo .xlsx');
      return;
    }

    if (!isExcelFileTypeValid(selectedFile)) {
      toastr.error(
        'Error',
        'El archivo seleccionado no es un archivo .xlsx válido',
      );
      return;
    }

    const newFormValues = {
      file: selectedFile,
    };

    onSubmit(newFormValues);
  };

  if (loading) return <Loader />;

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <FormGroup row>
        <FormItem>
          <Button onClick={downloadTemplate}>Descargar Plantilla</Button>
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <Col sm={3} xs={12}>
          <Label>Archivo</Label>
        </Col>
        <Col sm={9} xs={12}>
          <Input
            name="file"
            type="file"
            accept=".xlsx"
            onChange={onChangeFile}
          />
          {selectedFile && <FileDetailResource file={selectedFile} />}
        </Col>
      </FormGroup>
      <FormFooter>
        <Button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancelar
        </Button>
      </FormFooter>
    </form>
  );
};

CargoCorporateCreditCustomerModalForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchTemplate: PropTypes.func.isRequired,
  cargoCorporateCreditId: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = ({ CorporateUnit }) => ({
  loading: !CorporateUnit.CargoCorporateCredit.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchTemplate: getCargoCorporateCreditExcelTemplate,
};

const formComponent = reduxForm({
  form: 'cargoCorporateCreditCustomerModalForm',
})(CargoCorporateCreditCustomerModalForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
